// extracted by mini-css-extract-plugin
export default {"layout":"MainUserLayout_layout__ziaD-","flexBox":"MainUserLayout_flexBox__n28N4","zoom":"MainUserLayout_zoom__ungJK"};